import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
export function ProblemSection() {
  const fadeIn = useFadeIn();
  const painPoints = [{
    emoji: '🕒',
    text: 'Pasan los días y sentís que apenas compartís momentos reales con tus hijos o tu pareja.'
  }, {
    emoji: '📱',
    text: 'Todo se vuelve pantallas, trabajo y cansancio… y las charlas se hacen cada vez más cortas.'
  }, {
    emoji: '💤',
    text: 'Aunque amás a tu familia, muchas noches terminás con la sensación de que no estás aprovechando el tiempo juntos.'
  }, {
    emoji: '⚠️',
    text: 'Si no cambiás algo ahora, los días seguirán pasando sin esos recuerdos que tanto soñás crear.'
  }];
  return <section className="py-16 px-4 bg-black text-white border-y-8 border-red-600" data-id="element-184">
      <div className="max-w-3xl mx-auto" data-id="element-185">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-186">
          <div className="text-center mb-12" data-id="element-187">
            <h2 className="text-3xl md:text-5xl font-black text-yellow-400 mb-6" data-id="element-188">
              💔 Mientras tratás de conectar con tu familia… el tiempo se te
              escapa
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-189">
            {painPoints.map((point, idx) => <div key={idx} className="bg-gray-900 p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-190">
                <div className="text-4xl mb-3" data-id="element-191">{point.emoji}</div>
                <p className="text-lg text-gray-300 font-medium" data-id="element-192">
                  {point.text}
                </p>
              </div>)}
          </div>

          <div className="bg-gray-900 p-8 rounded-xl border border-gray-700 mt-12 shadow-2xl" data-id="element-193">
            <h3 className="text-2xl md:text-3xl font-black text-white mb-6 text-center" data-id="element-194">
              No es falta de amor ni de ganas ❤️
            </h3>
            <p className="text-xl text-gray-300 mb-4 text-center font-medium" data-id="element-195">
              Es que no tenés el método correcto para reconectar.
            </p>
            <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-196">
              No es falta de ganas, es que la rutina te roba el tiempo. Sin una
              guía que te motive a crear recuerdos reales, 💭 seguís dejando los
              momentos importantes "para después"… y después nunca es hoy.
            </p>

            <div className="space-y-4 mt-8" data-id="element-197">
              <p className="text-lg text-yellow-400 font-bold" data-id="element-198">
                🔑 Lo que necesitás es una herramienta que te devuelva el
                tiempo, te inspire y te ayude a crear recuerdos sin esfuerzo.
              </p>
              <p className="text-lg text-white font-medium" data-id="element-199">
                📔 Con las "100 Citas Familiares" vas a tener ideas listas para
                cada día, sin planificar nada.
              </p>
              <p className="text-lg text-gray-300" data-id="element-200">
                ✨ Solo elegís una cita, la compartís y disfrutás. Más conexión,
                más risas, más momentos inolvidables 💞
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}